'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishMessageWithAbly = publishMessageWithAbly;

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _MessageDescriptorSources = require('conversations-schema/constants/MessageDescriptorSources');

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _createNewThread = require('../../threads/actions/createNewThread');

var _applyGdprConsent = require('./applyGdprConsent');

var _publishMessage = require('./publishMessage');

var _addMessageToThread = require('./addMessageToThread');

var _addAvailabilityMessage = require('../../availability/actions/addAvailabilityMessage');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var _getMessageId = require('../../selectors/widgetDataSelectors/getMessageId');

var _getCurrentConversation = require('../../selectors/conversationSelectors/getCurrentConversation');

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _getCurrentThreadId = require('../../selectors/conversationSelectors/getCurrentThreadId');

var _isPersistedThread = require('../../thread-histories/operators/isPersistedThread');

var _getClientRole = require('../../selectors/pubNubMessageSelectors/getClientRole');

var _getPreviousMessageClientTs = require('../../selectors/pubNubMessageSelectors/getPreviousMessageClientTs');

var _getSenderId = require('../../selectors/pubNubMessageSelectors/getSenderId');

var _getSenderType = require('../../selectors/pubNubMessageSelectors/getSenderType');

var _clearAttachments = require('../../file-uploads/actions/clearAttachments');

var _trackSendMessage = require('./trackSendMessage');

var _initializePubSub = require('./initializePubSub');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function publishMessageWithAbly(_ref) {
  var text = _ref.text,
      richText = _ref.richText,
      quickReply = _ref.quickReply,
      url = _ref.url,
      attachments = _ref.attachments;

  return function (dispatch, getState) {
    var _metadata;

    var widgetData = (0, _getWidgetData.getWidgetData)(getState());
    var currentConversation = (0, _getCurrentConversation.getCurrentConversation)(getState());
    var isPersisted = (0, _isPersistedThread.isPersistedThread)(currentConversation);
    var channel = (0, _getCurrentChannel.getCurrentChannel)(getState());
    var threadId = (0, _getCurrentThreadId.getCurrentThreadId)(getState());

    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      metadata: (_metadata = {}, _defineProperty(_metadata, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.CHAT_MESSAGE), _defineProperty(_metadata, 'from', (0, _getClientRole.getClientRole)(getState())), _defineProperty(_metadata, 'richText', richText), _defineProperty(_metadata, 'text', text), _defineProperty(_metadata, 'quickReply', quickReply), _defineProperty(_metadata, 'url', url), _defineProperty(_metadata, 'attachments', attachments), _defineProperty(_metadata, 'welcomeMessageId', (0, _getMessageId.getMessageId)(getState())), _defineProperty(_metadata, 'previousMessageClientTs', (0, _getPreviousMessageClientTs.getPreviousMessageClientTs)(getState())), _metadata),
      descriptor: { channel: channel, source: _MessageDescriptorSources.THIS_CLIENT },
      senderId: (0, _getSenderId.getSenderId)(getState()),
      senderType: (0, _getSenderType.getSenderType)(getState()),
      threadId: (0, _getCurrentThreadId.getCurrentThreadId)(getState())
    });

    dispatch((0, _addMessageToThread.addMessageToThread)({ channel: channel, message: message }));

    dispatch((0, _clearAttachments.clearAttachments)(threadId));

    dispatch((0, _trackSendMessage.trackSendMessage)({ threadId: threadId }));

    dispatch((0, _initializePubSub.initializePubSub)()).then(function () {
      if (!isPersisted) {
        return dispatch((0, _createNewThread.createNewThread)());
      }
      return dispatch((0, _publishMessage.publishMessage)({ channel: channel, message: message })).then(function () {
        return dispatch((0, _applyGdprConsent.applyGdprConsent)({ widgetData: widgetData }));
      }).then(function () {
        return dispatch((0, _addAvailabilityMessage.addAvailabilityMessage)({ channel: channel }));
      });
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/publishMessageWithAbly.js
// module id = 643
// module chunks = 2 3